import { getProgramPolicy } from '../../../utils/programUtils';

export type NavigationEligibility = 'redirect' | undefined;

export function routeNavigationEligibility(
  pathname: string,
  _user: unknown,
  satAllowed = getProgramPolicy().isAllowed('sat'),
): NavigationEligibility {
  const redirect = pathname === '/' || pathname === '/sat' || pathname === '/isee'
    || pathname.startsWith('/next/app') || (!satAllowed && pathname.startsWith('/sat/'));
  if (redirect) return 'redirect';
  // v1-archive-p4a: /dev, /cb-preview*, /{sat,isee}/admin retired without
  // replacement (founder decision 2026-08-19). They now render Practice via
  // next-fallback -> RootRedirect, same as any other unmatched path -- there
  // is no admin-only surface left to classify here. Emitting 'access_denied'
  // for a path that no longer denies anything would be a fabricated
  // telemetry claim (AGENTS.md § Data & UI honesty).
  return undefined;
}
